import { ReactComponent as SvgSnowflake } from 'public/assets/icons/snowflakeFlat.svg';
import { ImageComponent } from 'components/common/ImageComponent';
import { IFeaturedResort } from 'api/home/types';
import { IResortPathInfo, IDescriptionsResort } from 'api/resort/types';
import { ReactComponent as SvgMarker } from 'public/assets/icons/marker.svg';
import { Link } from 'components/blocks/Button';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Routes } from 'routes';
import styles from './styles.module.scss';

interface Props {
  resort: IFeaturedResort | null;
  regionResorts?: Array<IResortPathInfo>;
  resortDescriptionTabs?: Array<IDescriptionsResort>;
}

export const FeaturedResort = ({ resort, regionResorts, resortDescriptionTabs }: Props) => {
  const { t } = useOTSTranslation('common');

  if (!resort) {
    return null;
  }

  const resortUuid = resort.uuid?.toString();
  const resortPathInfo = resortUuid && regionResorts
    ? regionResorts.find((item) => item.uuid === resortUuid)
    : undefined;

  if (!resortPathInfo) {
    return null;
  }

  const locationParts = [
    resort.region?.title,
    resort.region?.country,
  ].filter(Boolean) as Array<string>;

  const title = resort.title || 'Featured Resort';
  const location = locationParts.length ? locationParts.join(', ').toUpperCase() : null;

  const resortProfileTab = resortDescriptionTabs?.filter((item) => item.tab === 'resort_profile');
  let description = resortProfileTab && resortProfileTab.length > 0 ? resortProfileTab[0].description : null;

  if (description) {
    description = description.replace(/(<([^>]+)>)/gi, '');

    if (description.length > 250) {
      description = `${description.substring(0, 250)}...`;
    }
  }
  const linkHref = Routes.resortTripPlanningOverview(resortPathInfo);

  return (
    <section id={styles.featuredResort}>
      <div>
        <div>
          <ImageComponent alt={resort.title} src={resort.image ?? ''} />
        </div>

        <div className={styles.snowflake}>
          <SvgSnowflake width="100%" height="100%" viewBox="0 0 176 193" />
        </div>
      </div>

      <div className={styles.content}>
        <h6>{t('homePage.featuredResort')}</h6>
        <h3>{title}</h3>
        {location && (
          <div className={styles.row}>
            <SvgMarker />
            <p>{location}</p>
          </div>
        )}
        {description?.trim() && description !== null ? (
          // eslint-disable-next-line react/no-danger
          <p dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <p>No description available</p>
        )}
        <Link
          href={linkHref}
        >
          {t('common.seeResortGuide')}
        </Link>
      </div>
    </section>
  );
};
